<header class="header">
    <h1>
        Todo list
    </h1>
    <nav>
        <a routerLink="/">
            Home
        </a> | 
         <a routerLink="/about">
            About
        </a>
    </nav>
</header>